/**
 * Circular progress ring in the EDEN aesthetic — thin, elegant, muted gold.
 * Values 0-100. Renders a soft ring track + progress arc + centered content.
 */
export const ProgressRing = ({
    value = 0,
    size = 160,
    stroke = 3,
    label,
    sublabel,
    tone = "gold",
    className = "",
}) => {
    const r = (size - stroke) / 2;
    const c = 2 * Math.PI * r;
    const pct = Math.max(0, Math.min(100, value));
    const offset = c * (1 - pct / 100);
    const stroke_color = tone === "cream"
        ? "hsl(var(--eden-cream))"
        : tone === "sage"
        ? "hsl(var(--eden-sage))"
        : "hsl(var(--eden-gold))";
    const track = tone === "cream" ? "hsl(var(--eden-cream) / 0.18)" : "hsl(var(--foreground) / 0.09)";
    return (
        <div className={`relative inline-flex items-center justify-center ${className}`} style={{ width: size, height: size }}>
            <svg width={size} height={size} className="rotate-[-90deg]">
                <circle cx={size / 2} cy={size / 2} r={r} stroke={track} strokeWidth={stroke} fill="none" />
                <circle
                    cx={size / 2} cy={size / 2} r={r}
                    stroke={stroke_color} strokeWidth={stroke} fill="none"
                    strokeDasharray={c} strokeDashoffset={offset}
                    strokeLinecap="round"
                    style={{ transition: "stroke-dashoffset 1.4s cubic-bezier(0.22, 1, 0.36, 1)" }}
                />
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
                <div className="font-serif" style={{ fontSize: size * 0.28, lineHeight: 1 }}>{Math.round(pct)}</div>
                {label && <div className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground mt-2">{label}</div>}
                {sublabel && <div className="text-xs text-muted-foreground mt-1">{sublabel}</div>}
            </div>
        </div>
    );
};

export default ProgressRing;
